export default "__VITE_ASSET__CXycDMaR__"